import styled from 'styled-components';

export const MatchedResultSpan = styled.span`
  .result-highlighted-match {
    color: #ff5b00;
    background: #fff;
  }
`;
